import { render } from "./FormWozWaardeView.vue?vue&type=template&id=ac8f95c8"
import script from "./FormWozWaardeView.vue?vue&type=script&lang=js"
export * from "./FormWozWaardeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__